import { StyleSheet } from 'aphrodite'

import selector from './selector'
import navigation from './navigation'

export default {
  selector: StyleSheet.create(selector),
  navigation: StyleSheet.create(navigation)
}



// WEBPACK FOOTER //
// ./src/components/News/partials/Sidebar/style/index.js